import React, { useMemo, useState, useEffect, useRef } from "react";
import "../ReporteDocente.css";

const SelectorHeader = ({
  colegios,
  selectedColegio,
  setSelectedColegio,
  allDocentes,
  selectedDocente,
  setSelectedDocente,
  year,
  setYear,
  momento,
  setMomento,
  docenteSeleccionado,
  handleDownloadDocenteReport,
  disableDownload,
  ocultarSelectorColegio = false
}) => {
  /* =========================
     Estado local
     ========================= */
  const [colegioQuery, setColegioQuery] = useState("");
  const [mostrarListaColegios, setMostrarListaColegios] = useState(false);
  const [mostrarTodosColegios, setMostrarTodosColegios] = useState(false);

  const [docenteQuery, setDocenteQuery] = useState("");
  const [mostrarListaDocentes, setMostrarListaDocentes] = useState(false);
  const [mostrarTodosDocentes, setMostrarTodosDocentes] = useState(false);

  const colegioRef = useRef(null);
  const docenteRef = useRef(null);

  /* =========================
     Click fuera → cerrar listas
     ========================= */
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (colegioRef.current && !colegioRef.current.contains(e.target)) {
        setMostrarListaColegios(false);
      }
      if (docenteRef.current && !docenteRef.current.contains(e.target)) {
        setMostrarListaDocentes(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  /* =========================
     Colegios filtrados
     ========================= */
  const colegiosFiltrados = useMemo(() => {
    if (!colegios?.length) return [];
    if (mostrarTodosColegios || colegioQuery.trim() === "") {
      return [...colegios].sort((a, b) => a.localeCompare(b));
    }
    const q = colegioQuery.toLowerCase();
    return colegios
      .filter((c) => c.toLowerCase().includes(q))
      .sort((a, b) => a.localeCompare(b));
  }, [colegios, colegioQuery, mostrarTodosColegios]);

  /* =========================
     Base de docentes (GLOBAL o por colegio)
     ========================= */
  const docentesBase = useMemo(() => {
    if (!allDocentes?.length) return [];
    return selectedColegio
      ? allDocentes.filter((d) => d.colegio === selectedColegio)
      : allDocentes;
  }, [allDocentes, selectedColegio]);

  /* =========================
     Docentes filtrados
     ========================= */
  const docentesFiltrados = useMemo(() => {
    if (!docentesBase.length) return [];

    const q = docenteQuery.trim().toLowerCase();

    if (mostrarTodosDocentes || q === "") {
      return [...docentesBase].sort((a, b) =>
        a.profesor.localeCompare(b.profesor)
      );
    }

    return docentesBase
      .filter((d) => {
        const matchNombre = d.profesor.toLowerCase().includes(q);
        if (ocultarSelectorColegio) return matchNombre;
        return (
          matchNombre ||
          String(d.user_id || "").includes(docenteQuery.trim())
        );
      })
      .sort((a, b) => a.profesor.localeCompare(b.profesor));
  }, [docentesBase, docenteQuery, mostrarTodosDocentes, ocultarSelectorColegio]);

  /* =========================
     Render
     ========================= */
  return (
    <div className={`cintillo${ocultarSelectorColegio ? " cintillo-solo-docente" : ""}`}>
      <div className="cintillo-left">
        {/* Año */}
        <div className="momento-section">
          <select value={year} onChange={(e) => setYear(e.target.value)}>
            <option value="2025-2026">Año Escolar 2025-2026</option>
          </select>
        </div>

        {/* Momento */}
        <div className="momento-section">
          <select value={momento} onChange={(e) => setMomento(e.target.value)}>
            <option value="1">Momento I</option>
            <option value="2">Momento II</option>
            <option value="3">Momento III</option>
          </select>
        </div>

        {/* Colegio */}
        {!ocultarSelectorColegio && (
        <div className="colegio-section" ref={colegioRef}>
          <div className="dropdown-with-button">
            <div className="autocomplete-wrapper">
              <input
                type="text"
                placeholder="Buscar colegio…"
                value={colegioQuery}
                onChange={(e) => {
                  const value = e.target.value;
                  setColegioQuery(value);
                
                  // 🔴 SI BORRA EL TEXTO → reset colegio + docentes
                  if (value.trim() === "") {
                    setSelectedColegio("");
                    setSelectedDocente("");
                    setDocenteQuery("");
                
                    setMostrarTodosColegios(false);
                    setMostrarListaColegios(false);
                    setMostrarTodosDocentes(false);
                    setMostrarListaDocentes(false);
                    return;
                  }
                
                  setMostrarListaColegios(true);
                  setMostrarTodosColegios(false);
                }}
                onFocus={() => setMostrarListaColegios(true)}
              />
              <small className="autocomplete-counter">
                {colegiosFiltrados.length} / {colegios.length} colegios
              </small>

              {mostrarListaColegios && colegiosFiltrados.length > 0 && (
                <ul className="autocomplete-list">
                  {colegiosFiltrados.map((colegio, idx) => (
                    <li
                      key={idx}
                      onMouseDown={() => {
                        setSelectedColegio(colegio);
                        setColegioQuery(colegio);
                        setSelectedDocente("");
                        setDocenteQuery("");
                        setMostrarListaColegios(false);
                        setMostrarTodosColegios(false);
                      }}
                    >
                      {colegio}
                    </li>
                  ))}
                </ul>
              )}
            </div>

            {/* <button
              type="button"
              className="download-button secondary"
              onClick={() => {
                setMostrarTodosColegios((v) => !v);
                setMostrarListaColegios(true);
              }}
            >
              {mostrarTodosColegios ? "Ocultar" : "Ver todos"}
            </button> */}
          </div>
        </div>
        )}
      </div>

      {/* Docente */}
      <div className="docente-section" ref={docenteRef}>
        <div className="dropdown-with-button">
          <div className="autocomplete-wrapper">
            <input
              type="text"
              placeholder={
                ocultarSelectorColegio
                  ? "Buscar docente por nombre…"
                  : selectedColegio
                  ? "Buscar docente por nombre o ID…"
                  : "Buscar docente globalmente por nombre o ID…"
              }
              value={docenteQuery}
              onChange={(e) => {
                const value = e.target.value;
                setDocenteQuery(value);

                if (value.trim() === "") {
                  setSelectedDocente("");
                  if (!ocultarSelectorColegio) {
                    setSelectedColegio("");
                    setColegioQuery("");
                    setMostrarTodosColegios(false);
                    setMostrarListaColegios(false);
                  }
                  setMostrarTodosDocentes(false);
                  setMostrarListaDocentes(false);
                  return;
                }

                setMostrarListaDocentes(true);
                setMostrarTodosDocentes(false);
              }}
              onFocus={() => {
                if (docentesBase.length > 0) {
                  setMostrarListaDocentes(true);
                }
              }}
            />

            <small className="autocomplete-counter">
              {docentesFiltrados.length} / {docentesBase.length} docentes
            </small>

            {mostrarListaDocentes && docentesFiltrados.length > 0 && (
              <ul className="autocomplete-list">
                {docentesFiltrados.map((docente) => (
                  <li
                    key={docente.user_id}
                    onMouseDown={() => {
                      setSelectedDocente(docente.profesor);
                      setDocenteQuery(
                        ocultarSelectorColegio
                          ? docente.profesor
                          : `${docente.profesor} (${docente.user_id})`
                      );

                      if (!selectedColegio) {
                        setSelectedColegio(docente.colegio);
                        setColegioQuery(docente.colegio);
                      }

                      setMostrarListaDocentes(false);
                      setMostrarTodosDocentes(false);
                    }}
                  >
                    {ocultarSelectorColegio ? (
                      docente.profesor
                    ) : (
                      <>
                        {docente.profesor}{" "}
                        <strong>({docente.user_id})</strong>
                        <span style={{ marginLeft: 6, fontSize: 12, color: "#666" }}>
                          · {docente.colegio}
                        </span>
                      </>
                    )}
                  </li>
                ))}
              </ul>
            )}
          </div>

          {/* <button
            type="button"
            className="download-button secondary"
            disabled={docentesBase.length === 0}
            onClick={() => {
              setMostrarTodosDocentes((v) => !v);
              setMostrarListaDocentes(true);
            }}
          >
            {mostrarTodosDocentes ? "Ocultar" : "Ver todos"}
          </button> */}

          {/* <button
            className="download-button"
            onClick={() =>
              handleDownloadDocenteReport(docenteSeleccionado, selectedColegio)
            }
            disabled={disableDownload}
          >
            <i className="fa fa-download" />
          </button> */}
        </div>
      </div>
    </div>
  );
};

export default SelectorHeader;
